import { atom, selector } from "recoil";
import { TenantRequest, TenantRequestTouched } from "../types/tenants";
import { TENANT_DEFAULTS, TENANT_TOUCHED_DEFAULTS } from "../constants/tenants";

export const editTenantState = atom<TenantRequest>({
  key: "app.tenant.edit",
  default: TENANT_DEFAULTS,
});

export const editTenantTouchedState = atom<TenantRequestTouched>({
  key: "app.tenant.edit.touched",
  default: TENANT_TOUCHED_DEFAULTS,
});

export const editTenantValidState = selector<{
  [key in keyof TenantRequest]: boolean;
}>({
  key: "app.tenant.edit.valid",
  get: ({ get }) => {
    const fields = get(editTenantState);

    // SET ALL FIELDS TO BE VALID
    const validFields = Object.fromEntries(
      Object.keys(fields).map((key) => [key, true])
    ) as {
      [key in keyof TenantRequest]: boolean;
    };

    // VALIDATE REQUIRED FIELDS
    if (!fields.name) {
      validFields.name = false;
    }

    return validFields;
  },
});

export const editTenantErrorState = selector({
  key: "app.tenant.edit.error",
  get: ({ get }) => {
    const validFields = get(editTenantValidState);
    return Object.values(validFields).some((valid) => !valid);
  },
});
